import { TableContainer } from "@mui/material";
import { type Ref, forwardRef } from "react";
import type { ScrollerProps } from "react-virtuoso";
import { useTableVirtualizedSelectContext } from "../context";

export const VirtuosoTableContainer = forwardRef(function VirtuosoTable(
  { children, ...props }: ScrollerProps,
  ref: Ref<HTMLDivElement>
) {
  const { TableContainerProps } = useTableVirtualizedSelectContext();

  return (
    <TableContainer {...props} {...TableContainerProps} ref={ref}>
      {children}
    </TableContainer>
  );
});
